// src/redux/ordersSlice.js
import { createSlice } from "@reduxjs/toolkit";

export const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    collections: [],
    orders: [],
    totalOrders: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
  },
  reducers: {
    setCollections: (state, action) => {
      state.collections = action.payload;
    },
    setOrders: (state, action) => {
      state.orders = [...state.orders, ...action.payload];
    },
    setTotalOrders: (state, action) => {
      state.totalOrders = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
  },
});

export const {
  setCollections,
  setOrders,
  setTotalOrders,
  setCurrentPage,
  setPageSize,
} = ordersSlice.actions;

export default ordersSlice.reducer;
